module.exports = __webpack_public_path__ + "static/logo-759691e8621af542b0f4ebb9334d85d5.png";